module.exports = __webpack_public_path__ + "img/icon-navigation-close.0af3d18b.svg";